export default __webpack_public_path__ + "static/media/sad.2ceb281a.png";